<template>
  <v-container fluid>
    <router-link class="subtitle-1 grey-navy--text font-weight-bold text-decoration-none" :to="backRoute.link">
      <v-icon small class="pb-1"> keyboard_backspace </v-icon> {{ backRoute.text }}
    </router-link>
    <v-row>
      <v-col cols="4">
        <user-information :userId="this.userId" />
        <client-coach-information :userId="this.userId" />
      </v-col>
      <v-col cols="8" class="mt-3">
        <v-row>
          <v-col cols="12">
            <v-tabs v-model="tab" align-with-title>
              <v-tabs-slider color="secondary"></v-tabs-slider>

              <v-tab key="activity">
                Activity
              </v-tab>
              <v-tab key="chats">
                Chats
              </v-tab>
              <v-tab key="blocks">
                Block
              </v-tab>
              <v-tab key="comms">
                Communication
              </v-tab>
              <v-tab key="billing">
                Billing
              </v-tab>
              <v-tab key="check-ins">
                Check-in
              </v-tab>
              <v-tab key="goals">
                Goals
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item key="activity">
                <v-row>
                  <v-col cols="12">
                    <client-activity :userId="userId" />
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item key="chats">
                <v-row v-if="chatsForUser" class="px-5">
                  <v-col>
                    <v-row>
                      <v-col cols="12"
                        ><div class="d-flex justify-space-between">
                          <h2 class="primary--text">Chats</h2>
                          <v-btn color="secondary" outlined @click="createEditCoachingChatDialog = true"
                            >Create new Coaching Chat</v-btn
                          >
                        </div>
                      </v-col></v-row
                    >
                    <v-row>
                      <v-col cols="12">
                        <v-card>
                          <v-card-text>
                            <div v-for="chat in chatsForUser" :key="chat.id">
                              <chat-listing-card :chat="chat" :userId="userId" class="mt-2 mb-8" />
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item key="blocks">
                <recommended-journey :userId="userId" />
                <nutrition-block-history :userId="userId" />
              </v-tab-item>
              <v-tab-item key="comms">
                <client-communication :userId="userId" />
              </v-tab-item>
              <v-tab-item key="billing">
                <client-billing :userId="userId" />
              </v-tab-item>
              <v-tab-item key="check-ins">
                <client-check-in :userId="userId" />
              </v-tab-item>
              <v-tab-item key="goals">
                <client-goals-list :userId="userId" />
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-dialog
      persistent
      v-model="createEditCoachingChatDialog"
      width="600"
      class="limited-height"
      transition="dialog-bottom-transition"
    >
      <create-coaching-chat-card
        @closed="createEditCoachingChatDialog = false"
        @saved="coachingChatSaved"
        :user-id="userId"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import { extractNodes } from "@/lib/array";
import { CHATS_FOR_USER } from "@/graphql/queries/chat";
import UserInformation from "./blocks/UserInformation";
import ClientActivity from "./blocks/ClientActivity";
import ClientCommunication from "./blocks/ClientCommunication";
import ClientBilling from "./blocks/ClientBilling";
import ClientCheckIn from "./blocks/ClientCheckIn";
import ClientGoalsList from "./blocks/ClientGoalsList";
import ClientCoachInformation from "./blocks/ClientCoachInformation";
import RecommendedJourney from "@/components/workout_blocks/RecommendedJourney";
import NutritionBlockHistory from "@/components/workout_blocks/NutritionBlockHistory";
import ChatListingCard from "@/components/chats/ChatListingCard";
import CreateCoachingChatCard from "@/components/chats/CreateCoachingChatCard";

export default {
  props: ["userId"],
  components: {
    UserInformation,
    ClientActivity,
    ClientCommunication,
    ClientBilling,
    ClientCheckIn,
    ClientGoalsList,
    ClientCoachInformation,
    RecommendedJourney,
    NutritionBlockHistory,
    ChatListingCard,
    CreateCoachingChatCard,
  },
  data() {
    return {
      tab: null,
      createEditCoachingChatDialog: false,
      backRoute: {
        text: "Clients",
        link: "/clients",
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path.includes("/client-profile")) {
        vm.backRoute = {
          text: "Client Profile",
          link: from.path,
        };
      }
    });
  },
  created() {
    if (this.$route.query.cc) {
      // cc == create chat
      this.tab = 1; // brittle code. careful.
      this.createEditCoachingChatDialog = true;
      // reset querystring.
      history.pushState({}, null, this.$route.path);
    }
  },
  methods: {
    coachingChatSaved() {
      this.$apollo.queries.chatsForUser?.refetch();
      this.createEditCoachingChatDialog = false;
    },
  },
  apollo: {
    chatsForUser: {
      query: CHATS_FOR_USER,
      variables() {
        return {
          userId: this.userId,
        };
      },
      update: (data) => extractNodes(data.chatsForUser.edges),
      fetchPolicy: "cache-and-network",
    },
  },
};
</script>
